/**
 * Review Rating UI Component
 *
 * @example <sc-review-rating ng-model="vm.model" min="vm.min" max="vm.max"></sc-review-rating>
 * @description Component of Sandcastle Framework. Displays a review rating UI component.
 * @namespace Core
 * @memberof TR
 */

'use strict';

namespace Core {

    class ScReviewRating implements ng.IDirective {

        restrict: string;
        replace: boolean;
        transclude: boolean;
        scope: {};
        template;

        constructor() {

            this.restrict = 'E';
            this.replace = true;
            this.scope = {
                caption: '@',
                value: '=',
                max: '@',
                min: '@',
                step: '@',
                size: '@'
            };

            this.template =  `<div class="sc-c-range-bar
                                        sc-c-range-bar--readonly
                                        sc-c-range-bar--no-rating"
                                 ng-class="containerClasses">
                                <label class="sc-c-range-bar__label">{{::caption}}</label> 
                                <div class="sc-c-range-bar__block-wrapper">
                                    <label class="sc-c-range-bar__block"
                                          ng-class="{'sc-c-range-bar__block--selected' : r <= value}"
                                          ng-click="click.setValue(r)"
                                          ng-repeat="r in range">
                                    </label> 
                                </div>
                             </div>`;
        }

        link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel) => {
            const radix: number = 10;

            let min = parseInt(scope.min, radix),
                max = parseInt(scope.max, radix),
                step = parseInt(scope.step || 1, radix);

            //basic checks of our min, max and step values
            if (!(min < max) || step === 0 || (max-min)%step !== 0) {
                throw 'Rating picker - Invalid parameters';
            }

            //used for creating our datalist, used in UI only need to start counting
            //at min + step
            scope.range = _.range(min+step, max+step, step);

            let containerClasses = [];
            if(scope.size && scope.size.length > 0) {
               (<string[]>containerClasses).push(`sc-c-range-bar--${scope.size}`);
            }
            scope.containerClasses = containerClasses.join(' ');
        }

        static factory(): ng.IDirectiveFactory {
            const directive = () => new ScReviewRating();
            directive.$inject = [];
            return directive;
        }

    }

    const TR = angular.module('TR');
    TR.directive('scReviewRating', ScReviewRating.factory());

}
